/*
 *
 * AmlPopupConfirm
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 05-Sep-2024
*/

import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import AmlPopupConfirm from './AmlPopupConfirm'
import { doHidePopup } from 'Store/actions/popup'
import { doSubmitAml, doDownloadSurvey } from 'Route/Aml/modules/AmlActions'
import { nullSafe } from 'Utility/globalMethods'

const mapDispatchToProps = dispatch => ({
  doDownloadSurvey: (payload) => dispatch(doDownloadSurvey(payload)),
  doHidePopup: () => dispatch(doHidePopup()),
  doSubmitAml: (payload) => dispatch(doSubmitAml(payload))
})

const mapStateToProps = (state) => ({
  amlInfo: nullSafe(() => state.Aml.amlInfo, {}),
  isLoading: nullSafe(() => state.loading.localLoading.submit_aml, false),
  isLoadingDownload: nullSafe(() => state.loading.localLoading.download_survey, false),
  files: nullSafe(() => state.Aml.uploadedDocumentList, [])
})

export default connect(mapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, mergeProps) => ({
  ...stateProps,
  ...mergeProps,
  actions: dispatchProps
}))(AmlPopupConfirm)
